import { lighten } from '@mui/material/styles';
import { makeStyles } from '../../../styles';
const BACKGROUND_COLOR_LIGHTEN_COEFFICIENT = 0.875;
export const useStyles = makeStyles((theme) => ({
    root: Object.assign(Object.assign({}, theme.typography.label), { paddingLeft: theme.spacing(1), paddingRight: theme.spacing(1), '&.active': {
            color: theme.colors.success.dark,
            backgroundColor: theme.colors.success.light,
        }, '&.default': {
            color: theme.colors.primary.main,
            backgroundColor: theme.colors.primary.light,
        }, '&.warning': {
            color: theme.colors.warning.main,
            backgroundColor: theme.colors.warning.light,
        }, '&.error': {
            color: theme.colors.error.main,
            backgroundColor: theme.colors.error.light,
        }, '&.archived': {
            color: theme.colors.gray[700],
            backgroundColor: theme.colors.gray[100],
        }, '&.scheduled': {
            color: theme.colors.illustration.darkLavender,
            backgroundColor: lighten(theme.colors.illustration.darkLavender, BACKGROUND_COLOR_LIGHTEN_COEFFICIENT),
        } }),
}));
//# sourceMappingURL=Label.styles.js.map